module.exports = __webpack_public_path__ + "img/d201308-1.cc6a4e41.jpg";